export default "### What is the difference between Harberger Taxation and Partial Common Ownership?\n";